import http from "../httpService";
import { apiUrl } from "../../../config.js";

const apiEndpoint = apiUrl + "/finance/incoming-payment/";

export function saveIncomingPayment(incomingPayment) {
  return http.post(apiEndpoint, incomingPayment);
}

export function cancelIncomingPayment(invoiceID) {
  return http.delete(apiEndpoint + invoiceID);
}

export function getIncomingPayments() {
  return http.get(apiEndpoint);
}

export function getIncomingPaymentDetail(paymentID) {
  return http.get(apiEndpoint + "payment-detail/" + paymentID);
}

export function getIncomingPaymentByInvoice(invoiceID) {
  return http.get(apiEndpoint + "invoice-payments/" + invoiceID);
}

export function getIncomingPaymentsDocRef() {
  return http.get(apiEndpoint + "payment-doc-ref");
}
